import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Field, TagSelector } from '@dossierhq/design';
export function AuthKeyTagSelector({ state, dispatch }) {
    if (state.selectedIds.length === 0) {
        return null;
    }
    return (_jsxs(Field, { children: [_jsx(Field.Label, { size: "small", children: "Show entities with authorization key" }), _jsx(Field.Control, { children: _jsx(TagSelector, { clearLabel: "Clear", itemTag: (item) => ({ tag: item.displayName }), state: state, dispatch: dispatch }) })] }));
}
//# sourceMappingURL=AuthKeyTagSelector.js.map